import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {Auth0Provider} from '@auth0/auth0-react';
import {BrowserRouter} from 'react-router-dom';

// We'll load the config from a JSON file
fetch('/config.json')
    .then(response => response.json())
    .then(config => {
        const root = ReactDOM.createRoot(
            document.getElementById('root') as HTMLElement
        );

        // Calculate Auth0 domain by prepending "login." to the current hostname
        const auth0Domain =
            window.location.host === 'app.st.authlab.work' ? 'id.abbaspour.authlab.work' : 'id.abbaspour.net';
        //const apiUrl = `https://api.${window.location.hostname}/api`; // config.apiUrl
        const apiUrl =
            window.location.host === 'app.st.authlab.work' ? 'https://api.st.authlab.work/api' : 'https://api.st.abbaspour.net/api';

        root.render(
            <React.StrictMode>
                <Auth0Provider
                    domain={auth0Domain}
                    clientId={config.auth0.clientId}
                    authorizationParams={{
                        redirect_uri: window.location.origin,
                        audience: config.auth0.audience,
                        scope: "openid profile read"
                    }}
                    //cacheLocation="localstorage"
                >
                    <BrowserRouter>
                        <App apiUrl={apiUrl} audience={config.auth0.audience}/>
                    </BrowserRouter>
                </Auth0Provider>
            </React.StrictMode>
        );
    })
    .catch(error => {
        console.error('Failed to load configuration:', error);
        const root = document.getElementById('root');
        if (root) {
            root.innerHTML = '<div style="color: red; text-align: center; margin-top: 50px;"><h1>Error</h1><p>Failed to load application configuration. Please try again later.</p></div>';
        }
    });
